import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
    ViewEncapsulation,
    OnDestroy,
    ChangeDetectorRef,
} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { filter, Subject, take, takeUntil } from 'rxjs';
import packageJson from '../../../../../package.json';
import { AuthService, UserInfo } from '../../../../auth.service';

@Component({
    standalone: false,
    selector: 'lh-header',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './lh-header.component.html',
    styleUrls: ['./lh-header.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
})
export class LhHeaderComponent implements OnInit, OnDestroy {
    userName: string | undefined;
    hasBwRole: boolean = false;
    hasCogsRole: boolean = false;
    hasFinishedLubesRole: boolean = false;
    version: string = packageJson.version;

    private readonly _destroy$ = new Subject<void>();

    constructor(
        public router: Router,
        private authService: AuthService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.setUserConfig();
    }

    setUserConfig() {
        this.authService.getUser().subscribe((user) => {
            if (user) {
                this.userName = user.name ?? undefined;
                this.setRoles(user);
            } else {
                this.userName = undefined;
                this.hasBwRole = false;
                this.hasCogsRole = false;
                this.hasFinishedLubesRole = false;
            }
            this.cdr.markForCheck();
        });
    }

    setRoles(user: UserInfo) {
        const roles = (user.roles ?? []).map((r) => r.toLowerCase());

        this.hasBwRole = roles.includes('baseandwaxesreader');
        this.hasCogsRole = roles.includes('cogsreader');
        this.hasFinishedLubesRole = roles.includes('finishedlubesreader');
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    getAnimationData(outlet: RouterOutlet) {
        return (
            outlet &&
            outlet.activatedRouteData &&
            outlet.activatedRouteData?.['animation']
        );
    }

    isCurrentRoute(route: string) {
        return (this.router.url || '/').startsWith(route);
    }

    navigateTo(url: string) {
        this.router.navigateByUrl(url);
    }

    navigate(...commands: any[]) {
        this.router.navigate(commands);
    }
}
